import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpHelperService } from '../../shared/services/http-helper.service';
import { Observable } from 'rxjs';
import {
    IExtendedOrderLine,
    NumberTypeEnum,
    ReferenceNumberType,
    ReferenceNumberTypeDomestic,
    ReferenceNumberTypeInternational
} from '@cod-monorepo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class OrderLineService {
    protected baseUrl = environment.apiUrl;

    constructor(private httpClient: HttpClient, private httpHelperService: HttpHelperService) {}

    public getOrderLineItems(
        referenceNumber: string,
        type: ReferenceNumberTypeDomestic | ReferenceNumberTypeInternational | ReferenceNumberType | undefined
    ): Observable<IExtendedOrderLine[]> {
        const poType = this.extractPoType(type);
        let numberType = NumberTypeEnum.Delivery;

        switch (type) {
            case ReferenceNumberType.P24_DELIVERY_NUMBER:
            case ReferenceNumberType.P41_DELIVERY_NUMBER:
                numberType = NumberTypeEnum.Delivery;
                break;
            case ReferenceNumberType.P24_PURCHASE_ORDER_NUMBER:
            case ReferenceNumberType.P41_PURCHASE_ORDER_NUMBER:
            case ReferenceNumberType.P40_PURCHASE_ORDER_NUMBER:
                numberType = NumberTypeEnum.PurchaseOrder;
                break;
            case ReferenceNumberType.HANDLING_UNIT:
                numberType = NumberTypeEnum.HandlingUnit;
                break;
            case ReferenceNumberType.TRANSPORT_UNIT:
                numberType = NumberTypeEnum.TransportUnit;
                break;
            default:
                numberType = NumberTypeEnum.SalesOrder;
                break;
        }

        const normalizedReferenceNumber = referenceNumber.replace(/^0+/, '');

        return this.httpClient
            .get<IExtendedOrderLine[]>(`${this.baseUrl}/sap/${normalizedReferenceNumber}/extended-order-line-items`, {
                params: { ...(poType ? { type: poType, numberType } : {}) }
            })
            .pipe(this.httpHelperService.handleError('Error fetching order line items'));
    }

    public orderLineExists(
        referenceNumber: string,
        type: ReferenceNumberTypeDomestic | ReferenceNumberTypeInternational | ReferenceNumberType | undefined
    ): Observable<{ rowExists: boolean }> {
        const poType = this.extractPoType(type);

        const normalizedReferenceNumber = referenceNumber.replace(/^0+/, '');

        return this.httpClient
            .get<{ rowExists: boolean }>(`${this.baseUrl}/sap/${normalizedReferenceNumber}/exists`, {
                params: { ...(poType ? { type: poType } : {}) }
            })
            .pipe(this.httpHelperService.handleError('Error checking if order line exists'));
    }

    private extractPoType(type: string | undefined): string | undefined {
        switch (type) {
            case ReferenceNumberType.HANDLING_UNIT:
            case ReferenceNumberType.TRANSPORT_UNIT:
                return undefined;
            default:
                return type ? type.substring(0, 3) : undefined;
        }
    }
}
